/* eslint-disable lines-around-directive */
(function IIFE() {
    // eslint-disable-next-line strict
    'use strict';

    function WidgetPlayController(Translation, Widget) {
        'ngInject';

        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const vm = this;

        /**
         * Set parent controller.
         *
         * @param {Object} parentCtrl The parent controller object.
         */
        this.setParentController = function setParentController(parentCtrl) {
            vm.parentCtrl = parentCtrl;
        };

        /**
         * Get widget classes.
         *
         * @return {Array} An array of widget css classes.
         */
        function getWidgetClass() {
            const widgetClass = [];

            vm.parentCtrl.getWidgetClass(widgetClass);

            return widgetClass;
        }

        /**
         * The widget is empty when there is no video configured for the current language.
         * Handles the multi-language structure with multiple IDs:
         * { video: { en: { ids: ['abc', 'def'] }, fr: { ids: ['xyz'] } } }
         *
         * Also handles legacy formats:
         * 1. Single video: { video: { id: 'abc' } }
         * 2. Legacy: { videoId: 'abc' }
         */
        function isEmpty() {
            const inputLanguage = Translation.inputLanguage;
            const video = vm.widget.properties?.video;
            const videoId = vm.widget.properties?.videoId;
            const isInDesigner = vm.parentCtrl?.designerMode();

            // Priority 1: Check for new multi-language structure with ids array
            // In designer mode: direct language access; in viewer mode: translated with fallback
            const translatedVideo = isInDesigner ? video?.[inputLanguage] : Translation.translate(video);
            if (translatedVideo?.ids && Array.isArray(translatedVideo.ids) && translatedVideo.ids.length > 0) {
                return false;
            }

            // Priority 2: Check legacy single video structure: { video: { id: 'abc' } }
            // This format doesn't have language keys, so check the raw video object
            if (video && typeof video === 'object' && 'id' in video && video.id) {
                return false;
            }

            // Priority 3: Check legacy videoId format
            if (videoId) {
                return false;
            }

            return true;
        }

        /**
         * In designer mode, when the widget is empty, it is visible and displays
         * the widget type (play video)
         * Used by the designer mode.
         */
        function isWidgetEmpty() {
            return vm.parentCtrl.designerMode() && isEmpty();
        }

        /**
         * In reader mode, when the widget is empty, it is not displayed at all
         */
        function isWidgetHidden() {
            return !vm.parentCtrl.designerMode() && isEmpty();
        }

        /**
         * Update widget properties.
         * Used by the auto-migration hook to persist legacy format migrations.
         * Updates both the directive's scoped widget and the Widget service's current widget
         * to ensure the settings panel sees the changes.
         *
         * @param {Object} updatedProperties The updated properties.
         */
        function onChange(updatedProperties) {
            const mergedProperties = { ...vm.widget.properties, ...updatedProperties };

            // Update the directive's scoped widget
            vm.widget.properties = mergedProperties;

            // Update the Widget service's current widget (for settings panel)
            const currentWidget = Widget.getCurrent();
            if (currentWidget && currentWidget.uuid === vm.widget.uuid) {
                currentWidget.properties = mergedProperties;
            }
        }

        vm.getWidgetClass = getWidgetClass;
        vm.isWidgetEmpty = isWidgetEmpty;
        vm.isWidgetHidden = isWidgetHidden;
        vm.onChange = onChange;
    }

    function widgetPlayDirective() {
        'ngInject';

        function link(scope, el, attrs, ctrls) {
            ctrls[0].setParentController(ctrls[1]);
        }

        return {
            bindToController: true,
            controller: WidgetPlayController,
            controllerAs: 'vm',
            replace: true,
            require: ['widgetPlay', '^widget'],
            restrict: 'E',
            link,
            scope: {
                widget: '=',
            },
            templateUrl:
                '/client/front-office/modules/content/modules/widget/modules/widget-play/views/widget-play.html',
        };
    }

    window.angular.module('Widgets').directive('widgetPlay', widgetPlayDirective);
})();
